<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Piggy ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-piggy-mechanic-type :model.sync="model.mechanic"/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field label="Name" v-model.trim="model.name" hide-details/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field label="Key" v-model.trim="model.key" hide-details/>
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-bundle-settings-panel :model.sync="model"/>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
          <r-smart-offer-reset-currency :items.sync="model.resetCurrency" title="Reset Currency"/>
        </v-expansion-panels>
        <v-row dense class="pt-8">
          <v-col cols="12" sm="3" md="3">
            <v-text-field v-model.number="model.stageUp" label="Stage Up (Purchase)" hide-details/>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field v-model.number="model.stageDown" label="Stage Down (Lose)" hide-details/>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <r-piggy-stage-config-table :items.sync="model.stages" title="Stages"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {SmartOfferBundlePiggy} from "@/modules/redactor/models/smart-offer/bundle-piggy/SmartOfferBundlePiggy";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RPiggyMechanicType from "@/modules/redactor/views/smart-offer/bundle-piggy/r-piggy-mechanic-type.vue";
import RSmartOfferResetCurrency from "@/modules/redactor/views/smart-offer/r-smart-offer-reset-currency.vue";
import RBundleSettingsPanel from "@/modules/redactor/views/smart-offer/bundle-core/r-bundle-settings-panel.vue";
import RPiggyStageConfigTable from "@/modules/redactor/views/smart-offer/bundle-piggy/r-piggy-stage-config-table.vue";

export default {
  name: "r-smart-offer-bundle-piggy",
  components: {
    RPiggyStageConfigTable,
    RBundleSettingsPanel,
    RSmartOfferResetCurrency,
    RPiggyMechanicType,
    RGuardMoneyPanel,
    RGuardPanel
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundlePiggy(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    mechanic_code() {
      return this.model.mechanic ? this.model.mechanic.id : 0
    },
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundlePiggy();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
